import React from 'react';
import Media from 'react-media';

// basic breakpoints
export const TABLET_BREAKPOINT = 820;
export const DESKTOP_BREAKPOINT = 1366;

export const OnMobileOnly: React.FC = ({ children }) => (
  <Media query={`(max-width: ${TABLET_BREAKPOINT - 1}px)`} defaultMatches={false} render={() => children} />
);

export const OnTabletOnly: React.FC = ({ children }) => (
  <Media query={`(min-width: ${TABLET_BREAKPOINT}px) and (max-width: ${DESKTOP_BREAKPOINT - 1}px)`} defaultMatches={false} render={() => children} />
);

export const OnDesktopOnly: React.FC = ({ children }) => (
  <Media query={`(min-width: ${DESKTOP_BREAKPOINT}px)`} defaultMatches={false} render={() => children} />
);

export const OnTabletAndDesktopOnly: React.FC = ({ children }) => (
  <Media query={`(min-width: ${TABLET_BREAKPOINT}px)`} defaultMatches={false} render={() => children} />
);

export const OnMobileAndTabletOnly: React.FC = ({ children }) => (
  <Media query={`(max-width: ${DESKTOP_BREAKPOINT - 1}px)`} defaultMatches={false} render={() => children} />
);

export const OnTabletWithoutHoverOnly: React.FC = ({ children }) => (
  <Media query={`(min-width: ${TABLET_BREAKPOINT}px) and (hover: none) and (pointer: coarse)`} defaultMatches={false} render={() => children} />
);

export const OnTabletWithHoverOnly: React.FC = ({ children }) => (
  <Media query={`(min-width: ${TABLET_BREAKPOINT}px) and (hover: hover) and (pointer: fine)`} defaultMatches={false} render={() => children} />
);

// for IE
export const OnIEOnly: React.FC = ({ children }) => (
  <Media query="all and (-ms-high-contrast: none), (-ms-high-contrast: active)" defaultMatches={false} render={() => children} />
);

// window dimension
export const isBrowser = () => {
  return typeof window !== 'undefined';
};

export const getWindowDimensions = () => {
  if (!isBrowser()) {
    return { width: 0, height: 0 };
  }

  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const isMobile = () => window.matchMedia(`(max-width: ${TABLET_BREAKPOINT - 1}px)`).matches;
export const isTablet = () => window.matchMedia(`(min-width: ${TABLET_BREAKPOINT}px) and (max-width: ${DESKTOP_BREAKPOINT - 1}px)`).matches;
export const isDesktop = () => window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;
